import React from 'react';

export const ValueStatement = () => {
  return (
    <section className="py-10 px-4 bg-white">
      <div className="container mx-auto max-w-6xl">
        <div className="bg-gradient-to-br from-[#d97706] to-[#b45309] rounded-3xl p-12 md:p-16 shadow-2xl">
          <p className="text-white text-2xl md:text-3xl leading-relaxed text-center font-medium">
            We deliver personalized, hands-on training from day one, with no extra fees for additional practice. Our instructors evaluate each student's learning style and customize instruction to build both competence and confidence, ensuring every graduate is ready for the road.
          </p>
        </div>
      </div>
    </section>
  );
};
